<template>
  <div class="home-container">
    <!-- 首页英雄区 -->
    <section id="home" class="hero-section">
      <div class="container">
        <div class="hero-content">
          <h1 class="hero-title">知予 AI 心理陪伴平台</h1>
          <p class="hero-slogan">倾诉解忧，心结尽开</p>
          <p class="hero-subtitle">你的专属 AI 情绪树洞，温柔接住你的每一份情绪</p>
          <div class="hero-buttons">
            <el-button class="primary-btn" @click="scrollToDownload">立即体验</el-button>
            <el-button class="secondary-btn" @click="scrollToFeatures">了解更多</el-button>
          </div>
        </div>
        <div class="hero-image">
          <img src="@/assets/imgs/1.jpeg" alt="知予 AI 心理陪伴">
        </div>
      </div>
    </section>

    <!-- 盈利模式区 -->
    <section class="profit-section" id="profit">
      <div class="container">
        <h2 class="section-title">盈利模式</h2>
        <div class="profit-content">
          <div class="profit-card" @click="toProfit">
            <div class="profit-icon">
              <i class="el-icon-money"></i>
            </div>
            <h3 class="profit-title">聊天算力收费</h3>
            <div class="profit-details">
              <ul>
                <li><strong>按消息数量</strong>：灵活适应不同使用频率</li>
                <li><strong>按消息类型</strong>：设置不同消息类型的价格</li>
                <li><strong>会员制度</strong>：推出会员等级，增加用户粘性</li>
              </ul>
            </div>
          </div>
          <div class="profit-card" @click="toProfit">
            <div class="profit-icon">
              <i class="el-icon-position"></i>
            </div>
            <h3 class="profit-title">线下咨询转化</h3>
            <div class="profit-details">
              <ul>
                <li><strong>智能分流</strong>：AI识别需要深度干预的用户</li>
                <li><strong>咨询师展示</strong>：提升专业可信度</li>
                <li><strong>转化追踪</strong>：优化营销策略</li>
              </ul>
            </div>
          </div>
          <div class="profit-card" @click="toProfit">
            <div class="profit-icon">
              <i class="el-icon-data-analysis"></i>
            </div>
            <h3 class="profit-title">盈利数据</h3>
            <div class="profit-details">
              <ul>
                <li><strong>收入构成</strong>：AI聊天40%，线下转化60%</li>
                <li><strong>投资回报</strong>：初期投入低，利润率高</li>
                <li><strong>增长潜力</strong>：用户增加，边际成本递减</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 赚钱相关内容板块 -->
    <section class="profit-related-section">
      <div class="container">
        <h2 class="section-title">赚钱优势</h2>
        <div class="profit-related-content">
          <div class="profit-related-card">
            <div class="profit-related-icon">
              <i class="el-icon-s-marketing"></i>
            </div>
            <h3 class="profit-related-title">低投入高回报</h3>
            <p class="profit-related-desc">初期投入仅需服务器和AI模型费用，运营成本低，利润率高达70%以上</p>
            <div class="profit-related-data">
              <span class="data-number">70%+</span>
              <span class="data-label">利润率</span>
            </div>
          </div>
          <div class="profit-related-card">
            <div class="profit-related-icon">
              <i class="el-icon-s-custom"></i>
            </div>
            <h3 class="profit-related-title">用户增长迅速</h3>
            <p class="profit-related-desc">通过社交媒体引流和线下活动推广，用户群体快速扩大，收益呈指数增长</p>
            <div class="profit-related-data">
              <span class="data-number">200%</span>
              <span class="data-label">月增长率</span>
            </div>
          </div>
          <div class="profit-related-card">
            <div class="profit-related-icon">
              <i class="el-icon-s-flag"></i>
            </div>
            <h3 class="profit-related-title">市场需求旺盛</h3>
            <p class="profit-related-desc">心理健康市场需求持续增长，小程序作为轻量级入口具有巨大潜力</p>
            <div class="profit-related-data">
              <span class="data-number">3.5亿</span>
              <span class="data-label">潜在用户</span>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 成功案例板块 -->
    <section class="case-section" id="case">
      <div class="container">
        <h2 class="section-title">成功案例</h2>
        <div class="case-content">
          <div class="case-card">
            <div class="case-image">
              <img src="@/assets/imgs/2.jpeg" alt="心理机构案例">
            </div>
            <h3 class="case-title">心理机构</h3>
            <p class="case-desc">通过小程序月收入提升300%，线下咨询预约量增加200%</p>
            <div class="case-stats">
              <div class="stat-item">
                <span class="stat-number">300%</span>
                <span class="stat-label">收入增长</span>
              </div>
              <div class="stat-item">
                <span class="stat-number">200%</span>
                <span class="stat-label">预约增长</span>
              </div>
            </div>
          </div>
          <div class="case-card">
            <div class="case-image">
              <img src="@/assets/imgs/3.jpeg" alt="个人老师案例">
            </div>
            <h3 class="case-title">个人老师</h3>
            <p class="case-desc">通过小程序拓展服务范围，客户量增加150%，收入提升250%</p>
            <div class="case-stats">
              <div class="stat-item">
                <span class="stat-number">150%</span>
                <span class="stat-label">客户增长</span>
              </div>
              <div class="stat-item">
                <span class="stat-number">250%</span>
                <span class="stat-label">收入增长</span>
              </div>
            </div>
          </div>
          <div class="case-card">
            <div class="case-image">
              <img src="@/assets/imgs/4.jpeg" alt="企业服务案例">
            </div>
            <h3 class="case-title">企业服务</h3>
            <p class="case-desc">通过小程序为企业提供员工心理援助计划，签约企业增加80%</p>
            <div class="case-stats">
              <div class="stat-item">
                <span class="stat-number">80%</span>
                <span class="stat-label">企业增长</span>
              </div>
              <div class="stat-item">
                <span class="stat-number">50万+</span>
                <span class="stat-label">服务人次</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 核心功能区 -->
    <section id="features" class="features-section">
      <div class="container">
        <h2 class="section-title">核心功能</h2>
        <div class="features-grid">
          <div class="feature-card-3d">
            <div class="card-inner">
              <div class="card-front">
                <div class="feature-icon">
                  <i class="el-icon-chat-dot-round"></i>
                </div>
                <h3 class="feature-title">AI 情绪树洞</h3>
                <p class="feature-desc">24小时在线，随时倾听你的情绪，给予温柔回应</p>
              </div>
              <div class="card-back">
                <h3 class="feature-title">AI 情绪树洞</h3>
                <p class="feature-desc-back">我们的AI情绪树洞24小时在线，随时准备倾听你的情绪。无论你是开心、难过、焦虑还是愤怒，它都会给予你温柔的回应和理解，成为你最忠实的情绪倾听者。</p>
              </div>
            </div>
          </div>
          <div class="feature-card-3d">
            <div class="card-inner">
              <div class="card-front">
                <div class="feature-icon">
                  <i class="el-icon-lock"></i>
                </div>
                <h3 class="feature-title">隐私保护</h3>
                <p class="feature-desc">端到端加密，确保你的每一次倾诉都安全保密</p>
              </div>
              <div class="card-back">
                <h3 class="feature-title">隐私保护</h3>
                <p class="feature-desc-back">我们采用端到端加密技术，确保你的每一次倾诉都安全保密。你的所有对话内容仅存储在本地，不会被上传到任何服务器，让你可以放心地表达真实的自己。</p>
              </div>
            </div>
          </div>
          <div class="feature-card-3d">
            <div class="card-inner">
              <div class="card-front">
                <div class="feature-icon">
                  <i class="el-icon-sunny"></i>
                </div>
                <h3 class="feature-title">积极引导</h3>
                <p class="feature-desc">专业心理知识支持，帮助你建立积极的情绪管理方式</p>
              </div>
              <div class="card-back">
                <h3 class="feature-title">积极引导</h3>
                <p class="feature-desc-back">基于专业的心理学知识，我们的AI会给予你积极的引导，帮助你建立健康的情绪管理方式。通过科学的方法，让你学会如何应对生活中的挑战和压力。</p>
              </div>
            </div>
          </div>
          <div class="feature-card-3d">
            <div class="card-inner">
              <div class="card-front">
                <div class="feature-icon">
                  <i class="el-icon-magic-stick"></i>
                </div>
                <h3 class="feature-title">个性化服务</h3>
                <p class="feature-desc">根据你的情绪特点，提供定制化的心理陪伴方案</p>
              </div>
              <div class="card-back">
                <h3 class="feature-title">个性化服务</h3>
                <p class="feature-desc-back">我们的AI会根据你的情绪特点和需求，为你提供定制化的心理陪伴方案。通过不断学习和适应，它会越来越了解你，为你提供更加个性化的支持和建议。</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 产品优势区 -->
    <section class="advantages-section">
      <div class="container">
        <h2 class="section-title">产品优势</h2>
        <div class="advantages-radial">
          <!-- 中心品牌标识 -->
          <div class="advantages-center">
            <div class="brand-logo">
              <h3>知予 AI</h3>
              <p>心理陪伴平台</p>
            </div>
          </div>
          
          <!-- 四个优势项 -->
          <div class="advantage-item advantage-top-left">
            <div class="advantage-card">
              <div class="advantage-icon">
                <i class="el-icon-time"></i>
              </div>
              <h3 class="advantage-title">即时响应</h3>
              <p class="advantage-desc">无需等待，随时随地获得心理支持</p>
            </div>
          </div>
          
          <div class="advantage-item advantage-top-right">
            <div class="advantage-card">
              <div class="advantage-icon">
                <i class="el-icon-star-off"></i>
              </div>
              <h3 class="advantage-title">温柔陪伴</h3>
              <p class="advantage-desc">AI 共情能力强，更易感知你的情绪</p>
            </div>
          </div>
          
          <div class="advantage-item advantage-bottom-left">
            <div class="advantage-card">
              <div class="advantage-icon">
                <i class="el-icon-price-tag"></i>
              </div>
              <h3 class="advantage-title">无门槛</h3>
              <p class="advantage-desc">打破传统心理咨询的价格和时间门槛</p>
            </div>
          </div>
          
          <div class="advantage-item advantage-bottom-right">
            <div class="advantage-card">
              <div class="advantage-icon">
                <i class="el-icon-headset"></i>
              </div>
              <h3 class="advantage-title">专业支持</h3>
              <p class="advantage-desc">基于专业心理学理论，提供科学的情绪管理建议</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 操作流程区 -->
    <section class="process-section" id="process">
      <div class="container">
        <h2 class="section-title">操作流程</h2>
        <div class="process-steps">
          <div class="process-step">
            <div class="step-number">1</div>
            <h3 class="step-title">申请入驻</h3>
            <p class="step-desc">心理机构或个人咨询师申请入驻平台</p>
          </div>
          <div class="process-step">
            <div class="step-number">2</div>
            <h3 class="step-title">配置服务</h3>
            <p class="step-desc">设置咨询价格、服务内容和线下信息</p>
          </div>
          <div class="process-step">
            <div class="step-number">3</div>
            <h3 class="step-title">AI引流</h3>
            <p class="step-desc">通过AI小程序吸引用户，提供初步心理支持</p>
          </div>
          <div class="process-step">
            <div class="step-number">4</div>
            <h3 class="step-title">转化变现</h3>
            <p class="step-desc">引导用户付费咨询或线下服务</p>
          </div>
        </div>
      </div>
    </section>

    <!-- 用户场景区 -->
    <section id="scenarios" class="scenarios-section">
      <div class="container">
        <h2 class="section-title">用户场景</h2>
        <div class="scenarios-grid">
          <div class="scenario-card">
            <div class="scenario-image">
              <img src="@/assets/imgs/5.jpeg" alt="职场压力">
            </div>
            <h3 class="scenario-title">职场压力</h3>
            <p class="scenario-desc">面对工作压力和职业发展困惑，找到情绪出口</p>
          </div>
          <div class="scenario-card">
            <div class="scenario-image">
              <img src="@/assets/imgs/6.jpeg" alt="学业焦虑">
            </div>
            <h3 class="scenario-title">学业焦虑</h3>
            <p class="scenario-desc">应对考试压力和学习困扰，保持心理健康</p>
          </div>
          <div class="scenario-card">
            <div class="scenario-image">
              <img src="@/assets/imgs/7.jpeg" alt="失眠困扰">
            </div>
            <h3 class="scenario-title">失眠困扰</h3>
            <p class="scenario-desc">缓解失眠焦虑，改善睡眠质量</p>
          </div>
        </div>
      </div>
    </section>

    <!-- 小程序引流区 -->
    <section class="download-section">
      <div class="container">
        <h2 class="section-title">立即体验</h2>
        <div class="download-content">
          <div class="qrcode">
            <img src="@/assets/imgs/9.jpg" alt="小程序二维码">
            <p class="qrcode-text">扫码进入小程序</p>
          </div>
          <div class="download-info">
            <h3 class="download-title">知予 AI 心理陪伴</h3>
            <p class="download-desc">你的专属情绪树洞，随时随地为你提供心理支持</p>
            <div class="download-features">
              <el-tag class="feature-tag">24小时在线</el-tag>
              <el-tag class="feature-tag">隐私保护</el-tag>
              <el-tag class="feature-tag">专业支持</el-tag>
            </div>
          </div>
        </div>
      </div>
    </section>


    <!-- 关于我们区 -->
    <section id="about" class="about-section">
      <div class="container">
        <h2 class="section-title">关于我们</h2>
        <div class="about-content">
          <div class="about-image">
            <img src="@/assets/imgs/8.jpeg" alt="关于我们">
          </div>
          <div class="about-text">
            <h3 class="about-subtitle">知予 AI 心理陪伴平台</h3>
            <p class="about-desc">知予 AI 心理陪伴平台致力于为用户提供安全、专业、温暖的心理支持服务。我们的团队由专业的心理学家和技术专家组成，通过人工智能技术，为用户提供24小时在线的心理陪伴和支持。</p>
            <p class="about-desc">我们的使命是让每个人都能获得及时、有效的心理支持，打破传统心理咨询的门槛，让心理健康服务更加普及和可及。</p>
            <div class="about-features">
              <div class="about-feature">
                <i class="el-icon-user"></i>
                <span>专业团队</span>
              </div>
              <div class="about-feature">
                <i class="el-icon-date"></i>
                <span>24小时服务</span>
              </div>
              <div class="about-feature">
                <i class="el-icon-star-on"></i>
                <span>优质服务</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 联系与支持区 -->
    <section id="contact" class="contact-section">
      <div class="container">
        <h2 class="section-title">联系我们</h2>
        <div class="contact-content">
          <div class="contact-info">
            <p class="contact-item">
              <i class="el-icon-phone"></i>
              <span>联系电话：13100987983</span>
            </p>
            <p class="contact-item">
              <i class="el-icon-position"></i>
              <span>微信号：yxxgx9</span>
            </p>
            <p class="contact-item" style="align-items: flex-start;">
              <i class="el-icon-picture-outline"></i>
              <span><img src="https://h5smapp.dayujh.cn/upload/sys/image/69/9151955851f6033c3ac85bbdbea9a2.jpg" alt="微信二维码"
                    style="width: 220px;height: 300px;"></span>
            </p>
          </div>
          <div class="contact-form">
            <el-form :model="form" :rules="rules" ref="contactForm" label-position="top">
              <el-form-item label="姓名" prop="name">
                <el-input v-model="form.name" placeholder="请输入您的姓名"></el-input>
              </el-form-item>
              <el-form-item label="电话" prop="phone">
                <el-input v-model="form.phone" placeholder="请输入您的电话"></el-input>
              </el-form-item>
              <el-form-item label="公司名称" prop="company">
                <el-input v-model="form.company" placeholder="请输入您的公司名称"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" class="submit-btn" @click="submitForm" :loading="loading">提交</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'Home',
  data() {
    return {
      form: {
        name: '',
        phone: '',
        company: ''
      },
      rules: {
        name: [
          { required: true, message: '请输入姓名', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入电话', trigger: 'blur' }
        ],
        company: [
          { required: false, message: '请输入公司名称', trigger: 'blur' }
        ]
      },
      loading: false,
      observer: null
    }
  },
  mounted() {
    // 初始化IntersectionObserver，用于实现滚动入场动画
    this.observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate-in');
        }
      });
    }, {
      threshold: 0.1
    });
    
    // 观察所有需要动画的卡片元素
    const cards = document.querySelectorAll('.feature-card, .feature-card-3d, .advantage-item, .scenario-card, .profit-card, .profit-related-card, .case-card, .process-step');
    cards.forEach(card => {
      this.observer.observe(card);
    });
  },
  beforeDestroy() {
    // 销毁observer，避免内存泄漏
    if (this.observer) {
      this.observer.disconnect();
    }
  },
  methods: {
    toProfit() {
      this.$router.push('/profit');
    },
    scrollToDownload() {
      document.querySelector('.download-section').scrollIntoView({ behavior: 'smooth' });
    },
    scrollToFeatures() {
      document.querySelector('#features').scrollIntoView({ behavior: 'smooth' });
    },
    scrollToProfit() {
      document.querySelector('#profit').scrollIntoView({ behavior: 'smooth' });
    },
    scrollToCase() {
      document.querySelector('#case').scrollIntoView({ behavior: 'smooth' });
    },
    scrollToProcess() {
      document.querySelector('#process').scrollIntoView({ behavior: 'smooth' });
    },
    scrollToHome() {
      document.querySelector('#home').scrollIntoView({ behavior: 'smooth' });
    },
    scrollToScenarios() {
      document.querySelector('#scenarios').scrollIntoView({ behavior: 'smooth' });
    },
    scrollToAbout() {
      document.querySelector('#about').scrollIntoView({ behavior: 'smooth' });
    },
    submitForm() {
      this.$refs.contactForm.validate((valid) => {
        if (valid) {
          this.loading = true;
          // 构建请求参数
          const formData = {
            name: this.form.name,
            phone: this.form.phone,
            company: this.form.company
          };
          // 发送请求
          fetch('https://aixinli.dayujh.cn/admin/contact/submit', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
          })
          .then(response => response.json())
          .then(data => {
            this.loading = false;
            if (data.code === 200) {
              this.$message.success(data.msg);
              // 重置表单
              this.$refs.contactForm.resetFields();
            } else {
              this.$message.error(data.msg);
            }
          })
          .catch(error => {
            this.loading = false;
            this.$message.error('网络错误，请稍后重试');
            console.error('Error:', error);
          });
        } else {
          return false;
        }
      });
    }
  }
}
</script>

<style>
/* 动画样式 */
.feature-card, .advantage-item, .scenario-card, .profit-card, .profit-related-card, .case-card, .process-step {
  opacity: 0;
  transform: translateY(30px);
  transition: opacity 0.6s ease-out, transform 0.6s ease-out;
}

.feature-card.animate-in, .advantage-item.animate-in, .scenario-card.animate-in, .profit-card.animate-in, .profit-related-card.animate-in, .case-card.animate-in, .process-step.animate-in {
  opacity: 1;
  transform: translateY(0);
}

/* 为不同卡片添加交错动画延迟 */
.feature-card:nth-child(1) { transition-delay: 0.1s; }
.feature-card:nth-child(2) { transition-delay: 0.2s; }
.feature-card:nth-child(3) { transition-delay: 0.3s; }
.feature-card:nth-child(4) { transition-delay: 0.4s; }

.advantage-item:nth-child(1) { transition-delay: 0.1s; }
.advantage-item:nth-child(2) { transition-delay: 0.2s; }
.advantage-item:nth-child(3) { transition-delay: 0.3s; }
.advantage-item:nth-child(4) { transition-delay: 0.4s; }

/* 为3D卡片添加交错动画延迟 */
.advantage-item:nth-child(1) { transition-delay: 0.1s; }
.advantage-item:nth-child(2) { transition-delay: 0.2s; }
.advantage-item:nth-child(3) { transition-delay: 0.3s; }
.advantage-item:nth-child(4) { transition-delay: 0.4s; }

/* 产品优势区 */
.advantages-section {
  padding: 80px 0;
  background-color: white;
  position: relative;
}

.advantages-radial {
  position: relative;
  width: 100%;
  height: 600px;
  max-width: 800px;
  margin: 60px auto 0;
}

/* 中心品牌标识 */
.advantages-center {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 10;
}

.brand-logo {
  width: 200px;
  height: 200px;
  background: linear-gradient(135deg, #9c89b8, #b8bedd);
  border-radius: 50%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: white;
  box-shadow: 0 8px 24px rgba(156, 137, 184, 0.3);
  animation: pulse 3s ease-in-out infinite;
}

@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(156, 137, 184, 0.7);
  }
  70% {
    box-shadow: 0 0 0 20px rgba(156, 137, 184, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(156, 137, 184, 0);
  }
}

.brand-logo h3 {
  font-size: 28px;
  font-weight: bold;
  margin-bottom: 10px;
}

.brand-logo p {
  font-size: 16px;
  opacity: 0.9;
}

/* 优势项 */
.advantage-item {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 5;
}

.advantage-top-left {
  top: 0;
  left: 0;
}

.advantage-top-right {
  top: 0;
  right: 0;
}

.advantage-bottom-left {
  bottom: 0;
  left: 0;
}

.advantage-bottom-right {
  bottom: 0;
  right: 0;
}

/* 优势卡片 */
.advantage-card {
  background-color: white;
  border-radius: 20px;
  padding: 30px;
  text-align: center;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  width: 200px;
  transition: all 0.3s ease;
  position: relative;
}

.advantage-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.15);
}

/* 连接线 */
.advantage-item::before {
  content: '';
  position: absolute;
  background: linear-gradient(90deg, #9c89b8, #b8bedd);
  z-index: 1;
}

/* .advantage-top-left::before {
  width: 2px;
  height: 140px;
  bottom: -140px;
  left: 50%;
  transform: translateX(-50%) rotate(45deg);
}

.advantage-top-right::before {
  width: 2px;
  height: 140px;
  bottom: -50px;
  left: -60px;
  transform: rotate(45deg);
}

.advantage-bottom-left::before {
  width: 2px;
  height: 140px;
  top: -140px;
  left: 50%;
  transform: translateX(-50%) rotate(-45deg);
}

.advantage-bottom-right::before {
  width: 2px;
  height: 140px;
  top: -140px;
  left: 50%;
  transform: translateX(-50%) rotate(45deg);
} */

.advantage-icon {
  width: 60px;
  height: 60px;
  background: linear-gradient(135deg, #9c89b8, #b8bedd);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 15px;
  color: white;
  font-size: 24px;
  box-shadow: 0 4px 12px rgba(156, 137, 184, 0.3);
}

.advantage-title {
  font-size: 18px;
  font-weight: bold;
  color: #333;
  margin-bottom: 10px;
}

.advantage-desc {
  font-size: 14px;
  color: #666;
  line-height: 1.6;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .advantages-radial {
    height: 500px;
  }
  
  .brand-logo {
    width: 150px;
    height: 150px;
  }
  
  .brand-logo h3 {
    font-size: 24px;
  }
  
  .brand-logo p {
    font-size: 14px;
  }
  
  .advantage-card {
    width: 160px;
    padding: 20px;
  }
  
  .advantage-top-left::before,
  .advantage-top-right::before,
  .advantage-bottom-left::before,
  .advantage-bottom-right::before {
    height: 110px;
  }
  
  .advantage-title {
    font-size: 16px;
  }
  
  .advantage-desc {
    font-size: 13px;
  }
}

@media (max-width: 480px) {
  .advantages-radial {
    height: 400px;
  }
  
  .brand-logo {
    width: 120px;
    height: 120px;
  }
  
  .brand-logo h3 {
    font-size: 20px;
  }
  
  .brand-logo p {
    font-size: 12px;
  }
  
  .advantage-card {
    width: 120px;
    padding: 15px;
  }
  
  .advantage-top-left::before,
  .advantage-top-right::before,
  .advantage-bottom-left::before,
  .advantage-bottom-right::before {
    height: 90px;
  }
  
  .advantage-icon {
    width: 40px;
    height: 40px;
    font-size: 16px;
  }
  
  .advantage-title {
    font-size: 14px;
  }
  
  .advantage-desc {
    font-size: 12px;
  }
}

.scenario-card:nth-child(1) { transition-delay: 0.1s; }
.scenario-card:nth-child(2) { transition-delay: 0.2s; }
.scenario-card:nth-child(3) { transition-delay: 0.3s; }

.profit-card:nth-child(1) { transition-delay: 0.1s; }
.profit-card:nth-child(2) { transition-delay: 0.2s; }
.profit-card:nth-child(3) { transition-delay: 0.3s; }

.profit-related-card:nth-child(1) { transition-delay: 0.1s; }
.profit-related-card:nth-child(2) { transition-delay: 0.2s; }
.profit-related-card:nth-child(3) { transition-delay: 0.3s; }

.case-card:nth-child(1) { transition-delay: 0.1s; }
.case-card:nth-child(2) { transition-delay: 0.2s; }
.case-card:nth-child(3) { transition-delay: 0.3s; }

.process-step:nth-child(1) { transition-delay: 0.1s; }
.process-step:nth-child(2) { transition-delay: 0.2s; }
.process-step:nth-child(3) { transition-delay: 0.3s; }
.process-step:nth-child(4) { transition-delay: 0.4s; }

/* 首页容器 */
.home-container {
  margin-top: 70px;
}

/* 核心功能区 */
.features-section {
  padding: 80px 0;
  background: linear-gradient(135deg, #f5f7fa, #e9ecef);
  perspective: 1000px;
}

.features-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 30px;
  margin-top: 60px;
}

.feature-card-3d {
  perspective: 1000px;
  height: 350px;
}

.card-inner {
  position: relative;
  width: 100%;
  height: 100%;
  text-align: center;
  transition: transform 0.6s;
  transform-style: preserve-3d;
  border-radius: 20px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  border: 2px solid transparent;
  background: linear-gradient(#ffffff, #ffffff) padding-box, linear-gradient(135deg, #9c89b8, #b8bedd, #9c89b8) border-box;
  animation: neon-border 3s ease-in-out infinite;
}

@keyframes neon-border {
  0% {
    box-shadow: 0 0 5px rgba(156, 137, 184, 0.5), 0 0 10px rgba(156, 137, 184, 0.3);
  }
  50% {
    box-shadow: 0 0 20px rgba(156, 137, 184, 0.8), 0 0 30px rgba(156, 137, 184, 0.5);
  }
  100% {
    box-shadow: 0 0 5px rgba(156, 137, 184, 0.5), 0 0 10px rgba(156, 137, 184, 0.3);
  }
}

.feature-card-3d:hover .card-inner {
  transform: rotateY(180deg);
}

.card-front, .card-back {
  position: absolute;
  width: 100%;
  height: 100%;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  border-radius: 20px;
  padding: 40px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.card-front {
  background-color: white;
}

.card-back {
  background-color: white;
  transform: rotateY(180deg);
}

.feature-icon {
  width: 80px;
  height: 80px;
  background: linear-gradient(135deg, #9c89b8, #b8bedd);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 20px;
  color: white;
  font-size: 32px;
  box-shadow: 0 4px 12px rgba(156, 137, 184, 0.3);
}

.feature-title {
  font-size: 20px;
  font-weight: bold;
  color: #333;
  margin-bottom: 15px;
}

.feature-desc {
  font-size: 16px;
  color: #666;
  line-height: 1.6;
}

.feature-desc-back {
  font-size: 14px;
  color: #666;
  line-height: 1.6;
  text-align: center;
}

/* 为3D卡片添加动画 */
.feature-card-3d {
  opacity: 0;
  transform: translateY(30px);
  transition: opacity 0.6s ease-out, transform 0.6s ease-out;
}

.feature-card-3d.animate-in {
  opacity: 1;
  transform: translateY(0);
}

/* 为不同卡片添加交错动画延迟 */
.feature-card-3d:nth-child(1) { transition-delay: 0.1s; }
.feature-card-3d:nth-child(2) { transition-delay: 0.2s; }
.feature-card-3d:nth-child(3) { transition-delay: 0.3s; }
.feature-card-3d:nth-child(4) { transition-delay: 0.4s; }

/* 响应式设计 */
@media (max-width: 768px) {
  .feature-card-3d {
    height: 400px;
  }
  
  .card-front, .card-back {
    padding: 30px;
  }
}

@media (max-width: 480px) {
  .feature-card-3d {
    height: 450px;
  }
  
  .card-front, .card-back {
    padding: 20px;
  }
  
  .feature-title {
    font-size: 18px;
  }
  
  .feature-desc {
    font-size: 14px;
  }
  
  .feature-desc-back {
    font-size: 13px;
  }
}
</style>